import React from 'react';

const siteUrl = import.meta.env.VITE_FRONTEND_URL;

const baseUrl = siteUrl.endsWith('/') ? siteUrl.slice(0, -1) : siteUrl;

const sitemapLinks = [
  // website urls
`${baseUrl}/`,
`${baseUrl}/about-us`,
`${baseUrl}/frequently-asked-questions`,
`${baseUrl}/contact-us`,
`${baseUrl}/case-studies`,
`${baseUrl}/case-study/:slug`,
`${baseUrl}/disclaimer`,
`${baseUrl}/privacy-policy`,
`${baseUrl}/refund-policy`,
`${baseUrl}/terms-and-conditions`,
`${baseUrl}/cloud-hosting`,
`${baseUrl}/linux-hosting`,
`${baseUrl}/linux-reseller-hosting`,
`${baseUrl}/wordpress-hosting`,
`${baseUrl}/linux-cloud-vps`,
`${baseUrl}/windows-cloud-vps`,
`${baseUrl}/managed-linux-vps`,
`${baseUrl}/unmanaged-linux-vps`,
`${baseUrl}/dedicated-server-new-york`,
`${baseUrl}/dedicated-server-los-angeles`,
`${baseUrl}/dedicated-server-montreal`,
`${baseUrl}/dedicated-server-brazil`,
`${baseUrl}/dedicated-server-germany`,
`${baseUrl}/dedicated-server-india`,
`${baseUrl}/dedicated-server-singapore`,
`${baseUrl}/dedicated-server-uae`,
`${baseUrl}/streaming-server`,
`${baseUrl}/live-streaming-vod`,
`${baseUrl}/streaming-server-new-york`,
`${baseUrl}/streaming-server-los-angeles`,
`${baseUrl}/streaming-server-montreal`,
`${baseUrl}/streaming-server-london`,
`${baseUrl}/office-365`,
`${baseUrl}/cyber-security`,
`${baseUrl}/zimbra-mail-server`,
`${baseUrl}/ssl-certificate`,
`${baseUrl}/gpu-dedicated-server-germany`,
`${baseUrl}/gpu-dedicated-server-uk`,
`${baseUrl}/gpu-dedicated-server-france`,
`${baseUrl}/gpu-dedicated-server-netherlands`,
`${baseUrl}/gpu-dedicated-server-sweden`,
`${baseUrl}/gpu-dedicated-server-switzerland`,
`${baseUrl}/gpu-dedicated-server-ireland`,
`${baseUrl}/gpu-cloud-server-india`,
`${baseUrl}/gpu-dedicated-server-usa`,
`${baseUrl}/server-management`,
`${baseUrl}/backup-solutions`,
`${baseUrl}/our-team`,
`${baseUrl}/deals`,
`${baseUrl}/awards-and-recognitions`,
`${baseUrl}/work-culture`,
`${baseUrl}/aws-cloud-hosting`,
`${baseUrl}/azure`,
`${baseUrl}/google-cloud`,
`${baseUrl}/kubernetes`,
`${baseUrl}/odoo-server`,
`${baseUrl}/vtiger-solutions`,
`${baseUrl}/payment-options`,
`${baseUrl}/sitemap`,

  // blog urls
`${baseUrl}/blog/`,
`${baseUrl}/featured-blog/`,
`${baseUrl}/blog/why-your-website-crashes-on-launch-day/`,
`${baseUrl}/blog/migrate-your-website-without-downtime/`,
`${baseUrl}/blog/best-hosting-solutions-for-e-commerce-startups/`,
`${baseUrl}/blog/vps-vs-dedicated-hosting/`,
`${baseUrl}/blog/how-secure-is-your-hosting/`,
`${baseUrl}/blog/cloud-hosting-trends/`,
`${baseUrl}/blog/reseller-hosting-vs-shared-hosting/`,
`${baseUrl}/blog/hosting-mistakes/`,
`${baseUrl}/blog/how-managed-hosting-saves-time-and-money-for-agencies/`,
`${baseUrl}/blog/alternatives-of-chatgpt/`,
`${baseUrl}/blog/best-ai-tools/`,
`${baseUrl}/blog/seo-ranking-factors/`,
`${baseUrl}/blog/best-web-hosting-for-startups/`,
`${baseUrl}/blog/10-best-ai-productivity-tools/`,
`${baseUrl}/blog/use-ai-for-ad-campaigns/`,
`${baseUrl}/blog/what-is-virtualization/`,
`${baseUrl}/blog/generative-engine-optimization/`,
`${baseUrl}/blog/ai-image-prompt-tips/`,
`${baseUrl}/blog/how-to-delete-a-facebook-page/`,
`${baseUrl}/blog/how-to-write-a-newsletter/`,
`${baseUrl}/blog/ai-for-ppc/`,
`${baseUrl}/blog/topical-authority/`,
`${baseUrl}/blog/google-ads-account-structure/`,
`${baseUrl}/blog/get-found-online/`,
`${baseUrl}/blog/core-web-vitals/`,
`${baseUrl}/blog/how-to-start-a-blog-in-2025/`,
`${baseUrl}/blog/indias-ai-mission/`,
`${baseUrl}/blog/the-guide-to-nvidia-drivers/`,
`${baseUrl}/blog/how-to-integrate-chatgpt-into-wordpress/`,
`${baseUrl}/blog/marketing-automation/`,
`${baseUrl}/blog/wordpress-fundamentals/`,
`${baseUrl}/blog/best-wordpress-theme/`,
`${baseUrl}/blog/gpu-temp-range/`,
`${baseUrl}/blog/best-gpu-cards-for-high-performance/`,
`${baseUrl}/blog/e-commerce-business-growth/`,
`${baseUrl}/blog/ai-image-prompts-for-digital-art/`,
`${baseUrl}/blog/power-of-gpu-servers-for-financial-modeling/`,
`${baseUrl}/blog/gpu-dedicated-servers-enhancing-machine-learning-tasks/`,
`${baseUrl}/blog/ai-image-generators/`,
`${baseUrl}/blog/how-vtiger-crm-change-small-businesses/`,
`${baseUrl}/blog/ai-overviews-impacting-on-seo/`,
`${baseUrl}/blog/google-ads-not-working/`,
`${baseUrl}/blog/google-ads-performance-max/`,
`${baseUrl}/blog/optimize-facebook-lead-ads/`,
`${baseUrl}/blog/infinitive-host-leading-web-hosting-service-provider/`,
`${baseUrl}/blog/googles-new-ai-mode/`,
`${baseUrl}/blog/vtiger-crm-signature-field/`,
`${baseUrl}/blog/data-integration-with-vtiger/`,
`${baseUrl}/blog/google-ads-cost/`,
`${baseUrl}/blog/content-in-ai-era/`,
`${baseUrl}/blog/content-marketing-challenges/`,
`${baseUrl}/blog/google-ads-audience-targeting/`,
`${baseUrl}/blog/no-website-traffic/`,
`${baseUrl}/blog/google-ads-assets/`,
`${baseUrl}/blog/google-ai-overviews/`,
`${baseUrl}/blog/google-knowledge-panel/`,
`${baseUrl}/blog/nvidia-gpus-h100-vs-a100-a-detailed-comparison/`,
`${baseUrl}/blog/ai-in-cybersecurity-using-gpu-servers-to-detect-threats/`,
`${baseUrl}/blog/the-negative-impacts-of-artificial-intelligence-on-humanity/`,
`${baseUrl}/blog/what-is-deepseek/`,
`${baseUrl}/blog/dedicated-servers-with-nvidia-gpu-a-step-by-step-guide/`,
`${baseUrl}/blog/how-gpu-dedicated-servers-enhancing-machine-learning-tasks/`,
`${baseUrl}/blog/seamless-ai-integration-a-guide-to-vtiger-one-ai-edition/`,
`${baseUrl}/blog/a-complete-guide-to-the-top-streaming-server-for-2024/`,
`${baseUrl}/blog/why-linux-hosting-is-an-ideal-option-for-your-site-a-complete-guide/`,
`${baseUrl}/blog/what-is-windows-based-vps-hosting/`,
`${baseUrl}/blog/incredible-diwali-web-hosting-offers-get-exclusive-deals/`,
`${baseUrl}/blog/add-a-pdf-report-download-button-to-odoo-17-customer-portal/`,
`${baseUrl}/blog/a-complete-guide-about-mastering-python-threading-in-odoo-17/`,
`${baseUrl}/blog/gpu-accelerated-database-management-faster-query-processing/`,
`${baseUrl}/blog/gpu-servers-for-climate-modeling-environmental-research/`,
`${baseUrl}/blog/vtiger-crm-is-iso-27701-pims-certified-for-secure-hosting/`,
`${baseUrl}/blog/modify-field-properties-in-odoo-17-with-fields_get-method/`,
`${baseUrl}/blog/why-erp-systems-are-essential-for-company-digitalization/`,
`${baseUrl}/blog/comprehensive-guide-about-the-best-wordpress-themes-for-2024/`,
`${baseUrl}/blog/managed-wordpress-hosting-what-it-is-when-you-want-it/`,
`${baseUrl}/blog/comprehensive-step-by-step-guide-to-host-your-site-on-a-vps/`,
`${baseUrl}/blog/a-comprehensive-step-by-step-guide-to-install-java-on-ubuntu/`,
`${baseUrl}/blog/website-success-key-features-for-robust-digital-presence/`,
`${baseUrl}/blog/guide-to-wordpress-themes-for-real-estate-websites-in-2024/`,
`${baseUrl}/blog/elevate-your-travel-website-with-wordpresss-top-ten-themes/`,
`${baseUrl}/blog/guide-to-gpu-dedicated-servers-types-and-use-cases-for-2024/`,
`${baseUrl}/blog/whats-the-new-hype-for-ai-capable-gpus/`,
`${baseUrl}/blog/gpu-vs-cpu-how-are-they-different/`,
`${baseUrl}/blog/wordpress-hosting-the-ultimate-guide-to-choosing-the-right-provider/`,
`${baseUrl}/blog/how-gpu-servers-can-benefit-your-business/`,
`${baseUrl}/blog/top-10-best-web-hosting-companies-in-2024-a-comprehensive-review/`,
`${baseUrl}/blog/hosting-for-e-commerce-which-provider-is-best-for-your-online-store/`,
`${baseUrl}/blog/scalability-matters-finding-the-best-hosting-for-growing-businesses/`,
`${baseUrl}/blog/eco-friendly-web-hosting-companies-leading-the-green-revolution/`,
`${baseUrl}/blog/customer-support-showdown-which-web-hosting-companies-offer-the-best-service/`,
`${baseUrl}/blog/secure-your-website-the-most-reliable-hosting-providers-for-security/`,
`${baseUrl}/blog/comparing-the-fastest-web-hosting-services-speed-tests-and-results/`,
`${baseUrl}/blog/gpu-servers-are-reasonable-servers-what-you-need-to-know/`,
`${baseUrl}/blog/exploring-the-latest-innovations-in-gpu-server-hardware/`,
`${baseUrl}/blog/gpu-servers-in-the-cloud-hosting/`,
`${baseUrl}/blog/security-considerations-for-gpu-servers-protecting-your-high-value-resources/`,
`${baseUrl}/blog/building-a-cost-effective-gpu-server-for-your-startup-a-step-by-step-guide/`,
`${baseUrl}/blog/revolutionizing-real-time-data-analytics-with-gpu-servers/`,
`${baseUrl}/blog/the-role-of-gpu-servers-in-cryptocurrency-mining-and-blockchain/`,
`${baseUrl}/blog/difference-between-tcp-and-udp/`,
`${baseUrl}/blog/comparing-leading-gpu-server-providers-which-one-is-right-for-you/`,
`${baseUrl}/blog/optimising-gpu-server-performance-for-deep-learning/`,
`${baseUrl}/blog/the-future-of-gpu-servers-in-ai-and-machine-learning/`,
`${baseUrl}/blog/budget-friendly-hosting-solutions-affordable-options-that-deliver/`,
`${baseUrl}/blog/choose-the-best-web-hosting-company/`,
`${baseUrl}/blog/top-vtiger-crm-features-for-small-and-medium-enterprises/`,
`${baseUrl}/blog/vtiger-vs-salesforce-a-comparative-analysis/`,
`${baseUrl}/blog/an-introduction-to-vtiger-everything-you-need-to-know/`,
`${baseUrl}/blog/customizing-vtiger-crm-best-practices-and-tips/`,
`${baseUrl}/blog/customizing-odoo-tips-and-tricks-for-personalising-your-erp/`,
`${baseUrl}/blog/top-10-odoo-modules-for-small-businesses/`,
`${baseUrl}/blog/getting-started-with-odoo-a-beginners-guide/`,
`${baseUrl}/blog/top-10-cloud-security-vendors-and-companies/`,
`${baseUrl}/blog/pros-and-cons-of-managed-cloud-services/`,
`${baseUrl}/blog/security-risks-of-cloud-computing/`,
`${baseUrl}/blog/virtualisation-in-cloud-computing/`,
`${baseUrl}/blog/the-essential-role-of-cloud-orchestration-in-devops-culture-and-business-operations/`,
`${baseUrl}/blog/iaas-vs-paas-vs-saas/`,
`${baseUrl}/blog/cloud-security-challenges/`,
`${baseUrl}/blog/a-buyers-guide-to-cloud-managed-services/`,
`${baseUrl}/blog/benefits-of-managed-cloud-services/`,
`${baseUrl}/blog/how-to-use-data-analytics-and-cloud-solutions-to-solve-blockchain-challenges/`,
`${baseUrl}/blog/cloud-computing-and-data-centers/`,
`${baseUrl}/blog/how-to-leverage-cloud-technology-for-web-app-development/`,
`${baseUrl}/blog/best-practices-for-cost-optimization-through-managed-cloud-services/`,
`${baseUrl}/blog/managed-service-providers-vs-cloud-service-providers/`,
`${baseUrl}/blog/top-12-control-panels-of-2023/`,
`${baseUrl}/blog/setting-up-your-business-email-on-vps/`,
`${baseUrl}/blog/aws-security-best-practices-for-bfsi/`,
`${baseUrl}/blog/hyper-v-vs-vmware-which-is-better/`,
`${baseUrl}/blog/2023s-must-have-free-wordpress-themes/`,
`${baseUrl}/blog/ai-tools-for-software-developer-needs/`,
`${baseUrl}/blog/woocommerce-vs-magento-which-platform-fits-your-e-commerce/`,
`${baseUrl}/blog/vps-hosting-vs-cloud-hosting/`,
`${baseUrl}/blog/the-impact-of-aws-in-the-cloud-industry/`,
`${baseUrl}/blog/how-to-improve-core-web-vitals/`,
`${baseUrl}/blog/crafting-a-website-from-scratch/`,
`${baseUrl}/blog/9-tips-to-boost-your-core-web-vitals-in-wordpress/`,
`${baseUrl}/blog/cracking-the-code-of-the-https-port/`,
`${baseUrl}/blog/buying-managed-cloud-services/`,
`${baseUrl}/blog/linux-vps-hosting/`,
`${baseUrl}/blog/web-analytics-changer-your-business/`,
`${baseUrl}/blog/different-kinds-of-vps-servers-2023/`,
`${baseUrl}/blog/how-to-choose-a-managed-it-provider/`,
`${baseUrl}/blog/best-guide-to-help-you-start-your-blog/`,
`${baseUrl}/blog/major-limitations-of-chatbots/`,
`${baseUrl}/blog/jenkins-vs-kubernetes/`,
`${baseUrl}/blog/whats-the-best-video-bitrate-for-streaming/`,
`${baseUrl}/blog/a-comprehensive-guide-to-a-bare-metal-hypervisor/`,
`${baseUrl}/blog/best-audio-codec-for-live-streaming/`,
`${baseUrl}/blog/digitalocean-vs-aws-cloud-choose-one-business/`,
`${baseUrl}/blog/setup-e-commerce-business-with-magento/`,
`${baseUrl}/blog/why-is-video-streaming-so-popular/`,
`${baseUrl}/blog/the-latest-version-of-wordpress/`,
`${baseUrl}/blog/a-beginners-guide-to-aws-cloudfront/`,
`${baseUrl}/blog/what-is-email-server-how-does-it-work/`,
`${baseUrl}/blog/holiday-web-hosting-offers-2019/`,
`${baseUrl}/blog/how-ai-impacting-web-hosting-industry/`,
`${baseUrl}/blog/ddos-attack-types-mitigation-methods/`,
`${baseUrl}/blog/what-is-plesk-what-are-its-features/`,
`${baseUrl}/blog/vps-hosting-vs-business-hosting/`,
`${baseUrl}/blog/which-is-better-joomla-or-wordpress-for-your-ecommerce-store/`,
`${baseUrl}/blog/6-common-mistakes-choosing-web-host/`,
`${baseUrl}/blog/difference-between-reseller-hosting-and-shared-hosting/`,
`${baseUrl}/blog/shared-hosting/`,
`${baseUrl}/blog/6-essential-addons-need-upgraded-best-hosting-plans/`,
`${baseUrl}/blog/the-benefits-of-cloud-hosting-servers/`,
`${baseUrl}/blog/benefits-of-managed-dedicated-servers/`,
`${baseUrl}/blog/ultimate-security-guide-of-managed-vps-for-wordpress/`,
`${baseUrl}/blog/types-of-ssl-certificates-available-to-protect-your-website/`,
`${baseUrl}/blog/importance-of-white-label-hosting/`,
`${baseUrl}/blog/importance-of-ssl-in-business/`,
`${baseUrl}/blog/6-reasons-to-avoid-free-web-hosting/`,
`${baseUrl}/blog/how-to-migrate-magento-1-to-magento-2/`,
`${baseUrl}/blog/what-is-wp-staging-plugin-for-wordpress/`,
`${baseUrl}/blog/top-benefits-of-joomla-that-can-blow-your-mind/`,
`${baseUrl}/blog/tips-to-choose-right-cloud-service/`,
`${baseUrl}/blog/limitations-of-free-wordpress-hosting/`,
`${baseUrl}/blog/difference-between-ssd-and-hdd/`,
`${baseUrl}/blog/choose-best-vps-hosting-for-business/`,
`${baseUrl}/blog/benefits-of-vps-hosting-for-websites/`,
`${baseUrl}/blog/why-choose-linux-kvm-based-vps-hosting/`,
`${baseUrl}/blog/ways-to-choose-right-vps-hosting/`,
`${baseUrl}/blog/reasons-to-buy-dedicated-server/`,
`${baseUrl}/blog/difference-dedicated-hosting-cloud-hosting/`,
`${baseUrl}/blog/tips-choose-dedicated-servers-business/`,
`${baseUrl}/blog/3-signs-you-need-to-upgrade-your-shared-hosting-plan-to-vps/`,
`${baseUrl}/blog/misconception-about-dedicated-servers/`,
`${baseUrl}/blog/choose-best-dedicated-server-hosting/`,
`${baseUrl}/blog/vps-hosting-need-and-importance/`,
`${baseUrl}/blog/the-significance-of-dedicated-servers/`,
`${baseUrl}/blog/emergence-of-web-hosting-in-the-year-2022/`,
`${baseUrl}/blog/web-hosting-services-a-guide-for-beginners/`,
`${baseUrl}/blog/top-4-best-web-hosting-security-checklist-2019/`,
`${baseUrl}/blog/cloud-server-vs-dedicated-server/`,
`${baseUrl}/blog/renting-of-a-dedicated-server-works-in-india/`,
`${baseUrl}/blog/infinitive-host-streaming-server/`,
`${baseUrl}/blog/backup-recovery-strategy-for-business/`,
`${baseUrl}/blog/cloud-hosting-scalability/`,
`${baseUrl}/blog/importance-of-email-filtering-tool/`,
`${baseUrl}/blog/reasons-to-choose-vps-servers/`,
`${baseUrl}/blog/shared-hosting-vs-dedicated-hosting/`,
`${baseUrl}/blog/what-is-hls-protocol-and-how-it-works-a-simple-guide/`,
`${baseUrl}/blog/4-best-live-streaming-software-trending-in-2021/`,
`${baseUrl}/blog/how-to-choose-a-good-video-hosting-platform-for-your-business/`,
`${baseUrl}/blog/a-step-by-step-guide-on-how-to-make-your-wordpress-secure/`,
`${baseUrl}/blog/how-is-server-location-important-for-your-website-seo/`,
`${baseUrl}/blog/apache-vs-nginx-which-web-server-is-better/`,
`${baseUrl}/blog/how-do-cloud-servers-provide-better-security-and-performance/`,
`${baseUrl}/blog/which-hosting-service-is-best-for-smb/`,
`${baseUrl}/blog/5-common-web-hosting-problems/`,
`${baseUrl}/blog/why-does-your-ip-get-blacklisted/`,
`${baseUrl}/blog/fool-proof-guide-to-choosing-a-2022-ready-24-7-live-streaming-platform/`,
`${baseUrl}/blog/a-video-hosting-solution-for-your-business-growth-in-2022/`,
`${baseUrl}/blog/bigblue-button-v-s-jitsi-which-platform-is-better/`,
`${baseUrl}/blog/mp4-v-s-hls-v-s-dash-which-video-format-is-better-for-streaming/`,
`${baseUrl}/blog/how-is-ukraine-russia-war-impacting-web-hosting-businesses-in-india/`,
`${baseUrl}/blog/growing-demand-of-web-hosting-businesses-2022-25/`,
`${baseUrl}/blog/predictions-about-rising-demand-of-web-hosting-businesses-in-2028/`,
`${baseUrl}/blog/benefits-of-managed-web-hosting/`,
`${baseUrl}/blog/benefits-of-managed-wordpress-hosting/`,
`${baseUrl}/blog/6-types-of-web-hosting-you-should-know/`,
`${baseUrl}/blog/a-detailed-guide-to-cloud-hosting/`,
`${baseUrl}/blog/an-introduction-to-selinux/`,
`${baseUrl}/blog/containers-vs-virtual-machines/`,
`${baseUrl}/blog/ultimate-guide-to-what-is-http-2/`,
`${baseUrl}/blog/why-did-elon-musk-bought-twitter-5-changes-you-can-expect-on-the-platform/`,
`${baseUrl}/blog/all-about-web-server-and-its-types/`,
`${baseUrl}/blog/linux-vs-windows-which-hosting-is-best/`,
`${baseUrl}/blog/metaverse-all-you-need-to-know/`,
`${baseUrl}/blog/modsecurity-need-and-importance/`,
`${baseUrl}/blog/a-guide-to-web-application-firewall/`,
`${baseUrl}/blog/video-encoding-codes-compression-techniques/`,
`${baseUrl}/blog/top-open-source-web-hosting-panels/`,
`${baseUrl}/blog/all-you-need-to-know-about-ransomware/`,
`${baseUrl}/blog/zimbra-log4j/`,
`${baseUrl}/blog/how-hls-format-works/`,
`${baseUrl}/blog/multi-data-center-clustering/`,
`${baseUrl}/blog/a-beginners-guide-to-firewalld-in-rhel-centos-and-fedora/`,
`${baseUrl}/blog/difference-between-python-and-bash/`,
`${baseUrl}/blog/ipv4-vs-ipv6-what-is-the-difference/`,
`${baseUrl}/blog/difference-between-cpanel-and-plesk/`,
`${baseUrl}/blog/what-is-auto-scaling-how-is-it-works/`,
`${baseUrl}/blog/what-is-load-balancer-how-does-it-work/`,
`${baseUrl}/blog/tips-to-choose-successful-saas-hosting/`,
`${baseUrl}/blog/why-is-cpanel-email-going-to-spam-how-to-fix-it/`,
`${baseUrl}/blog/what-is-linux-load-average/`,
`${baseUrl}/blog/single-vs-dual-processor-servers/`,
`${baseUrl}/blog/what-is-smtp-mail-delivery-how-it-is-beneficial-for-business/`,
`${baseUrl}/blog/what-is-squid-proxy-server/`,
`${baseUrl}/blog/4-common-myths-about-cloud-computing/`,
`${baseUrl}/blog/5-cloud-computing-tips-for-businesses/`,
`${baseUrl}/blog/defining-san-storage-and-its-key-advantages-and-disadvantages/`,
`${baseUrl}/blog/cloud-based-backup-vs-physical-on-site-backup-which-is-best/`,
`${baseUrl}/blog/factors-for-choosing-hosting-provider/`,
`${baseUrl}/blog/guide-for-dark-tequila-threat-protection/`,
`${baseUrl}/blog/how-to-resolve-http-error-404-403/`,
`${baseUrl}/blog/how-to-migrate-enterprise-email-from-one-location-to-other/`,
`${baseUrl}/blog/how-to-protect-dedicated-server-from-a-cyber-attack/`,
`${baseUrl}/blog/what-is-the-inode-number-in-linux/`,
`${baseUrl}/blog/where-is-the-htaccess-file-in-joomla/`,
`${baseUrl}/blog/how-to-avoid-email-blacklists/`,
`${baseUrl}/blog/how-to-work-with-swap-space-on-linux-system/`,
`${baseUrl}/blog/chatgpt-expectation-v-s-reality/`,
`${baseUrl}/blog/chat-gpt-hacks-for-productivity-2023/`,
`${baseUrl}/blog/major-threats-aids-of-big-data-and-ai/`,
`${baseUrl}/blog/role-of-ai-to-enhance-cyber-security/`,
`${baseUrl}/blog/infinitive-host-announces-office-relocation-to-achieve-accelerated-growth/`,
`${baseUrl}/blog/all-in-one-guide-for-conversational-ai/`,
`${baseUrl}/blog/new-step-on-ai-journey-google-bard-ai/`,
`${baseUrl}/blog/how-ai-in-cybersecurity-transforms/`,
`${baseUrl}/blog/everything-about-datafication/`,
`${baseUrl}/blog/10-causes-of-slow-website/`,
`${baseUrl}/blog/rpa-v-s-ai/`,
`${baseUrl}/blog/robotic-process-automation-rpa/`,
`${baseUrl}/blog/how-datafication-is-transforming/`,
`${baseUrl}/blog/how-chatgpt-bard-ai-will-revolutionize-the-way-we-search/`,
`${baseUrl}/blog/ai-powered-bing-chatbot/`,
`${baseUrl}/blog/common-challenges-in-cloud-security/`,
`${baseUrl}/blog/everything-about-blockchain-technology/`,
`${baseUrl}/blog/bing-bard-chatgpt/`,
`${baseUrl}/blog/edge-computing/`,
`${baseUrl}/blog/best-magento-extensions-you-should-know-for-2023/`,
`${baseUrl}/blog/infinitivehost-6th-anniversary/`,
`${baseUrl}/blog/how-to-secure-%d0%b0-magento-2-online-store/`,
`${baseUrl}/blog/the-ultimate-web-hosting-guide/`,
`${baseUrl}/blog/exploring-the-metaverse/`,
`${baseUrl}/blog/edge-computing-2/`,
`${baseUrl}/blog/malware-protection-for-wordpress/`,
`${baseUrl}/blog/ai-empowers-language-understanding-nlp/`,
`${baseUrl}/blog/adopt-two-factor-authentication-today/`,
`${baseUrl}/blog/the-definitive-proxy-servers-guide/`,
`${baseUrl}/blog/ssd-nvme-vs-sata/`,
`${baseUrl}/blog/category/uncategorized/`,
`${baseUrl}/blog/category/google/`,
`${baseUrl}/blog/category/cloud/`,
`${baseUrl}/blog/category/virtual-private-server/`,
`${baseUrl}/blog/category/dedicated-server/`,
`${baseUrl}/blog/category/streaming-server/`,
`${baseUrl}/blog/category/featured/`,
`${baseUrl}/blog/category/cloud-hosting/`,
`${baseUrl}/blog/category/reseller-hosting/`,
`${baseUrl}/blog/category/web-hosting/`,
`${baseUrl}/blog/category/live-streaming-server/`,
`${baseUrl}/blog/category/shared-hosting/`,
`${baseUrl}/blog/category/website-security/`,
`${baseUrl}/blog/category/business-hosting/`,
`${baseUrl}/blog/category/email-hosting/`,
`${baseUrl}/blog/category/amazon-web-services/`,
`${baseUrl}/blog/category/wordpress/`,
`${baseUrl}/blog/category/news-updates/`,
`${baseUrl}/blog/category/magento-hosting/`,
`${baseUrl}/blog/category/cyber-security/`,
`${baseUrl}/blog/category/zimbra-hosting/`,
`${baseUrl}/blog/category/technology-featured/`,
`${baseUrl}/blog/category/control-panel/`,
`${baseUrl}/blog/category/joomla-hosting/`,
`${baseUrl}/blog/category/woocommerce/`,
`${baseUrl}/blog/category/gpu-server/`,
`${baseUrl}/blog/category/odoo/`,
`${baseUrl}/blog/category/vtiger-solutions/`,
`${baseUrl}/blog/category/vps-hosting/`,
`${baseUrl}/blog/category/google-ads/`,
`${baseUrl}/blog/category/website-traffic/`,
`${baseUrl}/blog/category/content-marketing/`,
`${baseUrl}/blog/category/facebook-ads/`,
`${baseUrl}/blog/category/seo/`,
`${baseUrl}/blog/category/artificial-intelligence/`,
`${baseUrl}/blog/category/gpu-dedicated-server/`,
`${baseUrl}/blog/category/e-commerce/`,
`${baseUrl}/blog/category/marketing-automation/`,
`${baseUrl}/blog/category/nvidia/`,
`${baseUrl}/blog/category/website-performance/`,
`${baseUrl}/blog/category/marketing/`,
`${baseUrl}/blog/category/newsletter/`,
`${baseUrl}/blog/category/facebook/`,
`${baseUrl}/blog/category/managed-hosting/`,
`${baseUrl}/blog/category/dedicated-hosting/`,
`${baseUrl}/blog/category/website-migration/`,
`${baseUrl}/blog/category/website-crashes/`,

// kb urls
`${baseUrl}/knowledge-base/g-suite-and-business-email/`,
`${baseUrl}/knowledge-base/website-speed-test/`,
`${baseUrl}/knowledge-base/domain-status-prohibited/`,
`${baseUrl}/knowledge-base/what-is-hsts/`,
`${baseUrl}/knowledge-base/secure-shell-port-number-22/`,
`${baseUrl}/knowledge-base/how-to-fix-invalid-cpf-for-br-domains/`,
`${baseUrl}/knowledge-base/about-gdpr/`,
`${baseUrl}/knowledge-base/manage-optimized-wordpress/`,
`${baseUrl}/knowledge-base/clear-cache/`,
`${baseUrl}/knowledge-base/uninstall-a-wordpress-site/`,
`${baseUrl}/knowledge-base/common-issues-after-migration/`,
`${baseUrl}/knowledge-base/wordpress-plugin-settings/`,
`${baseUrl}/knowledge-base/best-wordpress-plugins/`,
`${baseUrl}/knowledge-base/clear-web-browsers-cache/`,
`${baseUrl}/knowledge-base/troubleshooting-wordpress-login-issues/`,
`${baseUrl}/knowledge-base/update-php/`,
`${baseUrl}/knowledge-base/mastering-docker-and-kubernetes/`,
`${baseUrl}/knowledge-base/failover-infra-setup/`,
`${baseUrl}/knowledge-base/wordpress-blog-blank-pages/`,
`${baseUrl}/knowledge-base/upgrade-shared-hosting-to-vps/`,
`${baseUrl}/knowledge-base/npm-commands/`,
`${baseUrl}/knowledge-base/ssh-vs-ssl/`,
`${baseUrl}/knowledge-base/max-email-size-in-cpanel/`,
`${baseUrl}/knowledge-base/enable-disable-http-authentication/`,
`${baseUrl}/knowledge-base/almalinux/`,
`${baseUrl}/knowledge-base/react-app-deployment-cpanel/`,
`${baseUrl}/knowledge-base/linux-dedicated-server/`,
`${baseUrl}/knowledge-base/web-host-manager/`,
`${baseUrl}/knowledge-base/website-backup/`,
`${baseUrl}/knowledge-base/shared-hosting/`,
`${baseUrl}/knowledge-base/difference-between-domain-hosting-website/`,
`${baseUrl}/knowledge-base/what-are-ssl-https/`,
`${baseUrl}/knowledge-base/wordpress-seo-plugins/`,
`${baseUrl}/knowledge-base/wordpress-themes-with-wordpress-hosting/`,
`${baseUrl}/knowledge-base/install-wordpress/`,
`${baseUrl}/knowledge-base/wordpress-hosting/`,
`${baseUrl}/knowledge-base/how-to-update-wordpress/`,
`${baseUrl}/knowledge-base/supermicro-x11dpi-nt/`,
`${baseUrl}/knowledge-base/migration-process-for-your-wordpress-website/`,
`${baseUrl}/knowledge-base/how-to-run-a-computer-without-a-gpu-or-integrated-graphics/`,
`${baseUrl}/knowledge-base/show-header-first-page-footer-last-page-in-odoo-14/`,
`${baseUrl}/knowledge-base/fixing-odoo-10-database-restore-error-simple-solutions/`,
`${baseUrl}/knowledge-base/add-a-notification-pop-up-in-open-source-crm-easily/`,
`${baseUrl}/knowledge-base/change-your-vtiger-admin-password-in-simple-steps/`,
`${baseUrl}/knowledge-base/optimal-temperatures-for-a-long-lasting-gpu-performance/`,
`${baseUrl}/knowledge-base/how-to-stress-test-your-gpu-simple-guide/`,
`${baseUrl}/knowledge-base/odoo-17-create-sales-orders-with-gross-prices-easily/`,
`${baseUrl}/knowledge-base/troubleshooting-odoo-17-owl-module-fix-white-screen/`,
`${baseUrl}/knowledge-base/fix-cors-issues-with-socket-io-vtiger-and-csrf-magic-js/`,
`${baseUrl}/knowledge-base/move-vtiger-7-storage-test-directories-easily/`,
`${baseUrl}/knowledge-base/whats-the-safe-max-temp-for-an-hd-radeon-6870-gpu/`,
`${baseUrl}/knowledge-base/can-an-nvidia-gpu-render-if-monitor-uses-motherboard-port/`,
`${baseUrl}/knowledge-base/load-100-users-on-premade-selenium-scripts-in-odoo/`,
`${baseUrl}/knowledge-base/fix-model-not-found-error-in-odoo-12-simple-steps/`,
`${baseUrl}/knowledge-base/optimize-vtiger-crm-7x-understanding-meme-cache-varnish/`,
`${baseUrl}/knowledge-base/fix-non-admin-user-listview-access-issue-in-vtiger-crm-7-1-0/`,
`${baseUrl}/knowledge-base/how-to-show-related-emails-in-vtiger-compose-popup/`,
`${baseUrl}/knowledge-base/vtiger-7-1-installation-stuck-heres-how-to-fix-it/`,
`${baseUrl}/knowledge-base/why-are-workstation-graphics-card-so-expensive-compared-to-gpu/`,
`${baseUrl}/knowledge-base/fix-amd-graphics-drivers-wont-install-try-these-solutions/`,
`${baseUrl}/knowledge-base/how-to-connect-odoo-with-opc_ua-a-simple-integration-guide/`,
`${baseUrl}/knowledge-base/fix-v15-barcode-app-error-scan-products-at-picking-location/`,
`${baseUrl}/knowledge-base/best-software-to-monitor-gpu-temperature-on-windows-xp-7/`,
`${baseUrl}/knowledge-base/cpu-and-gpu-key-differences-explained-in-simple-terms/`,
`${baseUrl}/knowledge-base/limit-text-field-characters-in-odoo-tree-view-easy-guide/`,
`${baseUrl}/knowledge-base/give-project-edit-permission-in-odoo-17-with-ease-guide/`,
`${baseUrl}/knowledge-base/how-to-set-sql_mode-in-vtiger-without-the-pain/`,
`${baseUrl}/knowledge-base/find-record_id-for-rest-api-in-vtiger-crm-quick-guide/`,
`${baseUrl}/knowledge-base/why-do-gpus-have-hundreds-of-processors-find-out-here/`,
`${baseUrl}/knowledge-base/how-to-change-primary-monitor-at-boot-on-your-computer/`,
`${baseUrl}/knowledge-base/run-odoo-8-and-odoo-9-together-easy-setup-guide/`,
`${baseUrl}/knowledge-base/fix-database-restore-error-in-odoo12-simple-step-by-step-guide/`,
`${baseUrl}/knowledge-base/fix-nested-condition-issue-in-vtiger-rest-query-api/`,
`${baseUrl}/knowledge-base/fix-vtiger-installation-error-with-mysql-server-settings/`,
`${baseUrl}/knowledge-base/how-to-choose-your-primary-graphics-card-easily/`,
`${baseUrl}/knowledge-base/restart-your-video-card-driver-in-windows-7-easily/`,
`${baseUrl}/knowledge-base/add-time-field-in-odoo-15-models-database-simple-guide/`,
`${baseUrl}/knowledge-base/odoo-16-searchpanel-default-state-configuration-guide/`,
`${baseUrl}/knowledge-base/validate-vtiger-crm-6-2-custom-fields-with-jquery-easily/`,
`${baseUrl}/knowledge-base/export-import-custom-modules-in-vtiger-7-with-php/`,
`${baseUrl}/knowledge-base/fix-system-process-using-100-gpu-on-windows/`,
`${baseUrl}/knowledge-base/enable-graphics-card-or-change-aspect-ratio-in-safe-mode/`,
`${baseUrl}/knowledge-base/fix-odoo-17-app-not-showing-in-main-dropdown-menu/`,
`${baseUrl}/knowledge-base/fixing-odoo-models-linking-issues-with-self-id-error/`,
`${baseUrl}/knowledge-base/how-to-regenerate-user_privileges-files-easily-in-vtiger/`,
`${baseUrl}/knowledge-base/add-custom-dropdown-dynamically-from-db-in-vtiger-lead-form/`,
`${baseUrl}/knowledge-base/fixing-dda-device-out-of-resource-error-12-in-hyper-v-vm/`,
`${baseUrl}/knowledge-base/run-gpu-tasks-remotely-on-windows-server-2016-with-coding/`,
`${baseUrl}/knowledge-base/filter-journals-in-odoo-with-coding-a-simple-guide/`,
`${baseUrl}/knowledge-base/fix-import-whole-module-error-in-odoo-17-access-right-issue/`,
`${baseUrl}/knowledge-base/remove-1-custom-module-relationship-in-vtiger-with-php/`,
`${baseUrl}/knowledge-base/unregister-beforesave-and-aftersave-handler-in-vtiger-using-php/`,
`${baseUrl}/knowledge-base/understanding-odoo-model-relationships-a-quick-guide/`,
`${baseUrl}/knowledge-base/how-to-use-write-method-on-a-many2many-field-in-odoo/`,
`${baseUrl}/knowledge-base/fix-rtx-2070-fedora-31-nvidia-error-before-login/`,
`${baseUrl}/knowledge-base/how-to-use-gpu-passthrough-in-kvm-qemu-and-display-on-host/`,
`${baseUrl}/knowledge-base/how-to-fix-problems-while-installing-python-packages/`,
`${baseUrl}/knowledge-base/guide-to-installing-openerp-on-ubuntu-9-04-easy-steps/`,
`${baseUrl}/knowledge-base/create-php-function-for-users-by-role-in-vtiger-7/`,
`${baseUrl}/knowledge-base/relationship-in-vtiger-7-using-php-script-easily/`,
`${baseUrl}/knowledge-base/fix-login-failed-issue-using-vtwsclib-step-by-step-guide/`,
`${baseUrl}/knowledge-base/vtiger-7-crm-increase-document-title-length-with-php-script/`,
`${baseUrl}/knowledge-base/troubleshooting-nvlink-issues-with-2080-ti-gpus-quick-fixes/`,
`${baseUrl}/knowledge-base/set-up-kubernetes-master-on-google-cloud-with-on-premise-gpus/`,
`${baseUrl}/knowledge-base/delete-custom-blocks-fields-in-vtiger-crm-easily/`,
`${baseUrl}/knowledge-base/extend-vtiger-workflows-easily-a-step-by-step-guide/`,
`${baseUrl}/knowledge-base/easy-guide-to-installing-openerp-on-ubuntu/`,
`${baseUrl}/knowledge-base/how-to-host-openerp-locally-for-networked-computer-access/`,
`${baseUrl}/knowledge-base/boost-headless-servers-with-hardware-acceleration/`,
`${baseUrl}/knowledge-base/fix-xorg-not-starting-in-gke-with-gpu-ee-no-screens-found/`,
`${baseUrl}/knowledge-base/how-to-warn-users-when-your-server-is-under-maintenance/`,
`${baseUrl}/knowledge-base/set-up-apache-ssl-proxy-for-openerp-7-in-vm-easy-steps/`,
`${baseUrl}/knowledge-base/pod-is-scheduled-on-a-gpu-how-to-identify-in-kubernetes/`,
`${baseUrl}/knowledge-base/extend-1u-or-2u-servers-with-multiple-full-height-gpus/`,
`${baseUrl}/knowledge-base/how-to-clear-the-user-access-log-vtigercrm-7-3-open-source/`,
`${baseUrl}/knowledge-base/create-datetime-field-in-vtiger-7-crm-module-using-vtlib/`,
`${baseUrl}/knowledge-base/cant-create-user-in-vtiger-via-api-heres-how-to-fix-it/`,
`${baseUrl}/knowledge-base/remove-11-crm-module-relationships-with-php-in-vtiger-7/`,
`${baseUrl}/knowledge-base/fix-openerp-server-connection-issue-outside-wireless-network/`,
`${baseUrl}/knowledge-base/authenticated-through-lemonldapng-in-openerp-secure-login/`,
`${baseUrl}/knowledge-base/allow-openvpn-through-a-port-on-centos-6-5-simple-guide/`,
`${baseUrl}/knowledge-base/fix-postfix-error-sender-address-rejected-easy-solutions/`,
`${baseUrl}/knowledge-base/fixing-iptables-redirect-rule-issues-simple-steps/`,
`${baseUrl}/knowledge-base/secure-your-odoo-9-onsite-hosting-with-hyper-v-key-tips/`,
`${baseUrl}/knowledge-base/fixing-400-bad-request-with-apache-reverse-proxy-ssl/`,
`${baseUrl}/knowledge-base/kubernetes-container-file-ownership-issues-troubleshooting-guide/`,
`${baseUrl}/knowledge-base/do-servers-need-gpus-benefits-considerations/`,
`${baseUrl}/knowledge-base/fix-slurm-srun-gpu-allocation-error-easy-solutions/`,
`${baseUrl}/knowledge-base/how-to-identify-faulty-gpu-slot-in-server-with-ubuntu-command/`,
`${baseUrl}/knowledge-base/gcp-vm-creation-failure-no-gpu-capacity-available/`,
`${baseUrl}/knowledge-base/resolving-gcp-resource-shortages-for-requests-over-a-month/`,
`${baseUrl}/knowledge-base/enable-gpu-acceleration-on-windows-server-via-rdp/`,
`${baseUrl}/knowledge-base/gke-node-auto-provisioning-not-scaling-up-troubleshooting/`,
`${baseUrl}/knowledge-base/dedicated-gpus-for-kubernetes-pods-heres-how-it-works/`,
`${baseUrl}/knowledge-base/vtiger-webservice-error-access_denied-solution-guide/`,
`${baseUrl}/knowledge-base/step-by-step-guide-to-creating-custom-modules-in-vtiger-crm-6-5/`,
`${baseUrl}/knowledge-base/fix-vtigercrm-webform-error-webform-not-found/`,
`${baseUrl}/knowledge-base/fixing-error-creating-contacts-in-vtiger-crm-troubleshooting-guide/`,
`${baseUrl}/knowledge-base/fix-vtiger-7-custom-entity-module-display-issues/`,
`${baseUrl}/knowledge-base/revive-your-workflow-overcoming-time-constraints/`,
`${baseUrl}/knowledge-base/easy-steps-to-create-custom-module-in-vtiger-6/`,
`${baseUrl}/knowledge-base/easily-change-reply-to-email-in-vtiger-6-4-mail-manager/`,
`${baseUrl}/knowledge-base/how-to-easily-create-a-new-user-in-vtiger-7-using-webservice/`,
`${baseUrl}/knowledge-base/discover-vtiger-7-5-0-tab-icon-boost-productivity/`,
`${baseUrl}/knowledge-base/trouble-with-vtiger-7-3-0-lead-pagination-fix-now/`,
`${baseUrl}/knowledge-base/simplify-sales-orders-search-by-product-code-in-vtiger/`,
`${baseUrl}/knowledge-base/beforesave-vs-beforesave-modifiable-key-differences-explained/`,
`${baseUrl}/knowledge-base/create-a-module-for-vtiger-crm-easy-step-by-step-guide/`,
`${baseUrl}/knowledge-base/modify-field-or-block-position-in-vtiger-7-1-with-vtlib-guide/`,
`${baseUrl}/knowledge-base/create-custom-module-in-vtiger-crm-step-by-step-guide/`,
`${baseUrl}/knowledge-base/create-custom-module-in-vtiger7-with-vtlib-step-by-step-guide/`,
`${baseUrl}/knowledge-base/fix-php-crm-error-missing-or-incorrect-module-name/`,
`${baseUrl}/knowledge-base/outgoing-calls-from-vtiger-crm-to-asterisk-made-easy/`,
`${baseUrl}/knowledge-base/fix-unable-to-load-template-file-error-in-vtiger/`,
`${baseUrl}/knowledge-base/find-if-a-value-exists-in-your-db-using-php-and-sql/`,
`${baseUrl}/knowledge-base/fix-vtiger-unable-to-update-existing-crm-entries/`,
`${baseUrl}/knowledge-base/auto-create-calendar-events-from-custom-modules-in-vtiger/`,
`${baseUrl}/knowledge-base/customize-vtiger-crm-easily-with-style-less-guide/`,
`${baseUrl}/knowledge-base/vtiger-mailbox-configuration-issues-heres-a-quick-fix/`,
`${baseUrl}/knowledge-base/effortless-barcode-generator-for-vtiger-crm-try-it-now/`,
`${baseUrl}/knowledge-base/fix-email-template-issues-in-vtiger-crm-guide/`,
`${baseUrl}/knowledge-base/easily-modify-invoice-total-calculation-in-vtiger-crm-guide/`,
`${baseUrl}/knowledge-base/deny-url-access-in-odoo-with-nginxs-custom-404-error-page/`,
`${baseUrl}/knowledge-base/fix-live-chat-issues-after-ssl-cert-installation-easily/`,
`${baseUrl}/knowledge-base/fixing-nginx-redirected-too-much-error-easy-guide/`,
`${baseUrl}/knowledge-base/fix-subdomain-filtering-issues-quickly-and-easily/`,
`${baseUrl}/knowledge-base/install-openerp-with-four-tier-architecture-guide/`,
`${baseUrl}/knowledge-base/install-web-layer-in-openerp-8-as-stand-alone-server/`,
`${baseUrl}/knowledge-base/fix-odoo-configuration-errors-on-centos-6-6-easily/`,
`${baseUrl}/knowledge-base/how-to-define-a-route-to-a-lan-ip-easy-guide/`,
`${baseUrl}/knowledge-base/fixing-coma-in-url-after-proxy-with-apache-guide/`,
`${baseUrl}/knowledge-base/how-to-open-ports-for-docker-containers-easily/`,
`${baseUrl}/knowledge-base/resolve-unexpected-end-of-file-in-odoo-quickly/`,
`${baseUrl}/knowledge-base/postfix-allow-unlisted-senders-for-specific-ips/`,
`${baseUrl}/knowledge-base/proxy-another-domain-to-a-virtualhost-easy-guide/`,
`${baseUrl}/knowledge-base/effortless-aws-replication-for-running-odoo-a-quick-guide/`,
`${baseUrl}/knowledge-base/guide-to-installing-multiple-odoo-instances-on-one-machine/`,
`${baseUrl}/knowledge-base/fix-peer-authentication-failed-error-in-second-odoo-instance/`,
`${baseUrl}/knowledge-base/troubleshooting-odoo-10-page-wasnt-loaded-completely-issue/`,
`${baseUrl}/knowledge-base/optimize-varnish-for-odoo-boost-speed-and-performance/`,
`${baseUrl}/knowledge-base/troubleshooting-odoo-configuration-error-in-centos-6-6/`,
`${baseUrl}/knowledge-base/fix-fail2ban-regex-issue-on-odoo-logs-easy-solutions/`,
`${baseUrl}/knowledge-base/fixing-redirect-issues-in-odoo-with-nginx-simple-solutions/`,
`${baseUrl}/knowledge-base/odoo-10-ce-performance-tuning-enable-workers-for-speed/`,
`${baseUrl}/knowledge-base/how-to-size-compute-gpu-storage-network-for-generative-ai/`,
`${baseUrl}/knowledge-base/fix-amd-driver-issues-after-vm-reboot-with-gpu-passthrough/`,
`${baseUrl}/knowledge-base/understanding-nvidia-smi-and-lspci-grep-i-nvidia-output/`,
`${baseUrl}/knowledge-base/using-nvidia-a100-in-red-hat-openshift-compatibility-check/`,
`${baseUrl}/knowledge-base/hyper-v-gpu-passthrough-with-nvidia-a100-no-display-fix/`,
`${baseUrl}/knowledge-base/understanding-gpu-metrics-nvidia-smi-vs-guest-os-insights/`,
`${baseUrl}/knowledge-base/fix-pod-stuck-in-podinitializing-due-to-oomkilled-error/`,
`${baseUrl}/knowledge-base/dell-poweredge-r720xd-fans-ramp-up-when-video-card-installed/`,
`${baseUrl}/knowledge-base/gpu-aux-power-sockets-in-poweredge-t550-explained/`,
`${baseUrl}/knowledge-base/disable-gpu-scheduling-via-command-line-in-windows-10-11-guide/`,
`${baseUrl}/knowledge-base/monitor-windows-gpu-in-zabbix-step-by-step-guide/`,
`${baseUrl}/knowledge-base/optimizing-lm-sensor-for-intel-arc-a750-on-dell-r720-debian-11/`,
`${baseUrl}/knowledge-base/fixing-amdgpu-and-amdgpu-dkms-installation-issues/`,
`${baseUrl}/knowledge-base/how-to-mount-a-remote-gpu-locally-on-rocky-linux-easily/`,
`${baseUrl}/knowledge-base/fix-directx-12-support-on-vm-with-nvidia-l4-gpu-issue/`,
`${baseUrl}/knowledge-base/nvidia-smi-fix-missing-gpu-when-sr-iov-is-disabled-in-bios/`,
`${baseUrl}/knowledge-base/fixing-openstack-gpu-passthrough-prevents-instance-launch/`,
`${baseUrl}/knowledge-base/how-to-enable-opengl-on-windows-server-2022-simple-guide/`,
`${baseUrl}/knowledge-base/best-gpu-for-encoding-decoding-multiple-video-streams/`,
`${baseUrl}/knowledge-base/cisco-ucsc-c220-m4s-loud-fan-issue-fix-power-profile/`,
`${baseUrl}/knowledge-base/openstack-nova-pci-alias-is-not-defined-troubleshooting-guide/`,
`${baseUrl}/knowledge-base/allocated-gpus-vs-gpu-quota-in-runai-key-differences-explained/`,
`${baseUrl}/knowledge-base/fixing-ssl-issues-with-dovecot-easy-troubleshooting-guide/`,
`${baseUrl}/knowledge-base/fix-cloudfront-ssl-issues-a-quick-guide-to-secure-your-site/`,
`${baseUrl}/knowledge-base/solve-ssl-issues-on-mobile-websites-quickly-and-easily/`,
`${baseUrl}/knowledge-base/fix-debian-apache2-ssl-errors-ssl_error_rx_record_too_long/`,
`${baseUrl}/knowledge-base/cloud-server-vs-traditional-vps-which-to-choose/`,
`${baseUrl}/knowledge-base/inodes-limit-on-vps-cloud-servers-what-you-need-to-know/`,
`${baseUrl}/knowledge-base/how-to-set-up-google-cloud-server-email-forwarding/`,
`${baseUrl}/knowledge-base/troubleshoot-cloud-server-port-says-connection-refused/`,
`${baseUrl}/knowledge-base/cloud-servers-vs-vps-key-differences-explained-simply/`,
`${baseUrl}/knowledge-base/are-rackspaces-cloud-servers-truly-cloud-hosting-find-out/`,
`${baseUrl}/knowledge-base/fixing-ubuntu-webserver-misconfigurations-made-easy/`,
`${baseUrl}/knowledge-base/optimize-prestashop-with-nginx-and-reverse-proxy-setup/`,
`${baseUrl}/knowledge-base/fix-presta-shop-registration-errors-easily/`,
`${baseUrl}/knowledge-base/set-http_cf_connecting_ip-in-apache-server-config/`,
`${baseUrl}/knowledge-base/react-redux-combinereducer-issue-reducer-not-passed/`,
`${baseUrl}/knowledge-base/updating-users-via-put-method-in-cs-cart-rest-api-using-postman/`,
`${baseUrl}/knowledge-base/edit-main-content-block-in-cs-cart-step-by-step-guide/`,
`${baseUrl}/knowledge-base/understanding-cs-cart-file-paths-a-comprehensive-guide/`,
`${baseUrl}/knowledge-base/how-to-disable-cs-cart-compilation-and-boost-site-performance/`,
`${baseUrl}/knowledge-base/fix-permalink-issues-with-custom-taxonomy-post-types/`,
`${baseUrl}/knowledge-base/auto-accept-gradle-tos-for-build-scan-run-without-scan/`,
`${baseUrl}/knowledge-base/cocoa-core-data-newbie-how-tos-easy-steps-for-beginners/`,
`${baseUrl}/knowledge-base/how-to-retrieve-tos-value-on-a-tcp-socket/`,
`${baseUrl}/knowledge-base/how-to-set-message-priority-using-tos-complete-step-by-step-guide/`,
`${baseUrl}/knowledge-base/how-to-throw-an-exception-in-c-comprehensive-guide/`,
`${baseUrl}/knowledge-base/best-practices-for-api-versioning-expert-tips/`,
`${baseUrl}/knowledge-base/cloudflare-cdn-caching-and-google-analytics-common-doubts/`,
`${baseUrl}/knowledge-base/set-http_cf_connecting_ip-in-apache-easy-configuration/`,
`${baseUrl}/knowledge-base/fix-flot-chart-pie-tooltip-not-showing-easy-guide/`,
`${baseUrl}/knowledge-base/how-to-easily-reset-cs-cart-admin-password-quick-guide/`,
`${baseUrl}/knowledge-base/seamlessly-integrate-directsmile-with-cs-cart-for-success/`,
`${baseUrl}/knowledge-base/fix-huge-performance-issues-after-migration-easy-solutions/`,
`${baseUrl}/knowledge-base/switching-from-fasthosts-find-your-perfect-managed-email-solution/`,
`${baseUrl}/knowledge-base/effortless-laravel-5-2-installation-on-shared-hosting-quick-guide/`,
`${baseUrl}/knowledge-base/laravel-project-authorization-header-issue/`,
`${baseUrl}/knowledge-base/err-ssl-protocol-error-troubleshooting/`,
`${baseUrl}/knowledge-base/update-your-react-app-code-best-practices-for-deployment/`,
`${baseUrl}/knowledge-base/vps-troubleshooting-fix-failed-to-get-installation-access-token/`,
`${baseUrl}/knowledge-base/fix-ssl-issues-on-python-easily/`,
`${baseUrl}/knowledge-base/easy-guide-cloudflare-subdomain-to-digital-ocean-droplet/`,
`${baseUrl}/knowledge-base/troubleshooting-404-error-in-codeigniter-on-digital-ocean/`,
`${baseUrl}/knowledge-base/easy-laravel-image-upload-resize-for-digital-ocean/`,
`${baseUrl}/knowledge-base/solving-entrypoints-error-digitalocean-troubleshooting/`,
`${baseUrl}/knowledge-base/fix-git-error-src-refspec-master-does-not-match-any/`,
`${baseUrl}/knowledge-base/fix-cannot-read-properties-error-in-seconds/`,
`${baseUrl}/knowledge-base/unlock-wordpress-rest-api-potential-with-php-curl/`,
`${baseUrl}/knowledge-base/boost-security-php-update-cloud-linux-hardening/`,
`${baseUrl}/knowledge-base/troubleshooting-xml-sitemaps-fix-yoast-404-error/`,
`${baseUrl}/knowledge-base/effortlessly-create-fullscreen-maps-with-elementor-html/`,
`${baseUrl}/knowledge-base/custom-select-field-for-woocommerce-by-country/`,
`${baseUrl}/knowledge-base/easy-json-data-posting-with-curl-quick-guide/`,
`${baseUrl}/knowledge-base/easy-remote-folder-copy-with-scp-step-by-step-guide/`,
`${baseUrl}/knowledge-base/easy-sql-server-table-update-add-default-value/`,
`${baseUrl}/knowledge-base/easy-javascript-email-validation-validate-steps/`,
`${baseUrl}/knowledge-base/prevent-sql-injection-in-php-6-simple-tips-for-secure-code/`,
`${baseUrl}/knowledge-base/unveiling-plesk-effortless-http-access-without-a-domain/`,
`${baseUrl}/knowledge-base/fix-dsn-plesk-is-invalid-error-in-plesk-installation-quick-solutions/`,
`${baseUrl}/knowledge-base/sql-server-update-data-from-select-query-complete-guide/`,
`${baseUrl}/knowledge-base/fix-next-js-classname-error-easily-use-usecontext/`,
`${baseUrl}/knowledge-base/guide-serving-index-html-directly-on-root-domain-with-namecheap-hosting-and-bitbucket/`,
`${baseUrl}/knowledge-base/where-are-the-access-log-and-error-log-files-for-my-server/`,
`${baseUrl}/knowledge-base/how-to-check-mysql-version-via-command-line/`,
`${baseUrl}/knowledge-base/install-joomla-via-cpanel/`,
`${baseUrl}/knowledge-base/configure-sendinblue-smtp/`,
`${baseUrl}/knowledge-base/how-do-i-change-the-time-zone-on-my-server/`,
`${baseUrl}/knowledge-base/how-to-configure-ses-smtp-on-cpanel-whm/`,
`${baseUrl}/knowledge-base/how-to-install-bigbluebutton-in-ubuntu/`,
`${baseUrl}/knowledge-base/how-to-configure-greylisting-cpanel-whm/`,
`${baseUrl}/knowledge-base/configure-zoho-smtp-on-cpanel-whm/`,
`${baseUrl}/knowledge-base/how-to-install-iredmail-centos-7/`,
`${baseUrl}/knowledge-base/how-to-secure-memcache-on-centos-7/`,
`${baseUrl}/knowledge-base/how-to-restart-php-fpm-whm/`,
`${baseUrl}/knowledge-base/how-to-create-a-php-info-page/`,
`${baseUrl}/knowledge-base/how-to-install-wordpress-with-an-auto-installer-cwp/`,
`${baseUrl}/knowledge-base/how-do-i-create-a-catch-all-email-account-in-cpanel/`,
`${baseUrl}/knowledge-base/restore-email-using-outlook/`,
`${baseUrl}/knowledge-base/how-do-i-clear-the-mail-queue/`,
`${baseUrl}/knowledge-base/how-do-i-change-email-account-passwords-on-cpanel/`,
`${baseUrl}/knowledge-base/how-to-install-wordpress-in-directadmin-using-softaculous/`,
`${baseUrl}/knowledge-base/wordpress-multisite/`,
`${baseUrl}/knowledge-base/to-create-data-backup-in-directadmin-account/`,
`${baseUrl}/knowledge-base/how-to-restore-data-backup-in-directadmin-account/`,
`${baseUrl}/knowledge-base/how-to-activate-lets-encrypt-ssl-certificate-for-your-website/`,
`${baseUrl}/knowledge-base/how-to-change-and-check-the-php-version-of-a-domain-on-directadmin-server/`,
`${baseUrl}/knowledge-base/how-to-create-an-ftp-account-in-directadmin/`,
`${baseUrl}/knowledge-base/how-to-access-direct-admin-panel/`,
`${baseUrl}/knowledge-base/access-webmail-directadmin/`,
`${baseUrl}/knowledge-base/email-in-directadmin/`,
`${baseUrl}/knowledge-base/steps-to-check-site-at-local-end-in-linux/`,
`${baseUrl}/knowledge-base/steps-to-check-site-at-local-end-in-windows/`,
`${baseUrl}/knowledge-base/install-ssl-certificate-using-lets-encrypt-in-directadmin/`,
`${baseUrl}/knowledge-base/how-to-tune-php-fpm-settings-on-cwp-cpanel-and-core-server-having-centos-7-installed/`,
`${baseUrl}/knowledge-base/how-to-add-site-redirect-in-directadmin/`,
`${baseUrl}/knowledge-base/how-to-add-new-domains-in-directadmin/`,
`${baseUrl}/knowledge-base/how-to-configure-gzip-compression-with-nginx/`,
`${baseUrl}/knowledge-base/how-do-i-use-the-nslookup-tool-provided-with-windows/`,
`${baseUrl}/knowledge-base/how-to-reset-laravel-admin-password-directly-from-the-database/`,
`${baseUrl}/knowledge-base/steps-to-add-google-workspace-email-account-to-outlook/`,
`${baseUrl}/knowledge-base/how-renew-your-services-with-infinitivehost/`,
`${baseUrl}/knowledge-base/how-to-check-mails-send-by-infinitive-host-from-its-client-area/`,
`${baseUrl}/knowledge-base/how-to-buy-hosting-from-infinitive-host/`,
`${baseUrl}/knowledge-base/how-to-check-the-status-of-your-invoice-in-infinitive-host-client-area/`,
`${baseUrl}/knowledge-base/how-to-pay-an-invoice-from-infinitive-host-client-area/`,
`${baseUrl}/knowledge-base/how-to-check-the-status-of-your-tickets-in-infinitive-host-client-area/`,
`${baseUrl}/knowledge-base/how-to-open-a-ticket-in-infinitive-host-client-area/`,
`${baseUrl}/knowledge-base/how-to-login-to-infinitive-host-client-area/`,
`${baseUrl}/knowledge-base/how-to-reset-infinitive-host-client-area-password/`,
`${baseUrl}/knowledge-base/how-to-resolve-the-deceptive-site-ahead-error/`,
`${baseUrl}/knowledge-base/how-to-host-a-domain-in-virtualmin-panel/`,
`${baseUrl}/knowledge-base/how-to-generate-csr-in-virtualmin-server/`,
`${baseUrl}/knowledge-base/installing-cpanel-on-centos-7/`,
`${baseUrl}/knowledge-base/how-to-install-nginx-rtmp-media-server/`,
`${baseUrl}/knowledge-base/how-to-install-jitsi-meet-video-conferencing-server-on-ubuntu-20/`,
`${baseUrl}/knowledge-base/mariadb-galera-cluster-on-centos-7/`,
`${baseUrl}/knowledge-base/step-by-step-guide-for-creating-private-name-servers-in-godaddy-panel/`,
`${baseUrl}/knowledge-base/how-do-i-run-a-ping-and-trace-route-test/`,
`${baseUrl}/knowledge-base/steps-to-login-linux-server-using-putty/`,
`${baseUrl}/knowledge-base/installing-nodejs-14-x-in-centos-and-rhel/`,
`${baseUrl}/knowledge-base/how-to-optimize-apache-web-server-with-plesk-panel/`,
`${baseUrl}/knowledge-base/how-to-restart-apache-server-from-plesk/`,
`${baseUrl}/knowledge-base/how-to-restart-mysql-server-from-plesk/`,
`${baseUrl}/knowledge-base/how-to-change-your-mysql-root-password-via-plesk/`,
`${baseUrl}/knowledge-base/how-to-manage-your-hosting-packages-in-plesk/`,
`${baseUrl}/knowledge-base/how-to-terminate-multiple-domain-in-plesk/`,
`${baseUrl}/knowledge-base/how-to-suspend-a-domain-in-whm-panel/`,
`${baseUrl}/knowledge-base/how-to-enable-autossl/`,
`${baseUrl}/knowledge-base/how-to-install-whm-cpanel-on-centos-7/`,
`${baseUrl}/knowledge-base/how-to-enable-ssh-shell-access-in-cpanelwhm-on-vps/`,
`${baseUrl}/knowledge-base/how-to-install-redis-and-php-redis-extension-on-whm-server/`,
`${baseUrl}/knowledge-base/how-to-install-csf-firewall-via-whm-panel/`,
`${baseUrl}/knowledge-base/how-to-enable-disable-cphulk-brute-force-protection-via-whm-panel/`,
`${baseUrl}/knowledge-base/how-to-change-hostname-in-whm-panel/`,
`${baseUrl}/knowledge-base/how-to-install-imagick-extension-for-a-php-version-from-whm/`,
`${baseUrl}/knowledge-base/how-to-install-node-js-on-cpanel-server-via-whm-panel/`,
`${baseUrl}/knowledge-base/how-to-access-the-in-browser-terminal-interface-from-whm-panel/`,
`${baseUrl}/knowledge-base/how-to-optimize-apache-web-server-via-whm-panel/`,
`${baseUrl}/knowledge-base/how-to-modify-a-cpanel-account-with-whm-panel/`,
`${baseUrl}/knowledge-base/how-to-delete-a-hosting-package-from-whm-panel/`,
`${baseUrl}/knowledge-base/how-to-increase-max-upload-size-of-phpmyadmin/`,
`${baseUrl}/knowledge-base/how-to-create-email-ids-in-cwp-server/`,
`${baseUrl}/knowledge-base/how-to-create-csr-in-cwp-panel/`,
`${baseUrl}/knowledge-base/how-to-host-a-domain-in-cwp-panel/`,
`${baseUrl}/knowledge-base/how-to-create-a-database-in-cwp-phpmyadmin/`,
`${baseUrl}/knowledge-base/import-export-mysql-database/`,
`${baseUrl}/knowledge-base/steps-to-install-lets-encrypt-in-cwp-panel/`,
`${baseUrl}/knowledge-base/how-to-whitelist-ip-in-csf-firewall/`,
`${baseUrl}/knowledge-base/how-to-suspend-and-unsuspend-accounts-in-cwp-panel/`,
`${baseUrl}/knowledge-base/how-to-reboot-a-vps-dedicated-server-via-cwp-panel/`,
`${baseUrl}/knowledge-base/how-to-restart-mysql-server-from-cwp-panel/`,
`${baseUrl}/knowledge-base/cpanel-vs-control-web-panel/`,
`${baseUrl}/knowledge-base/set-up-csf-firewall-to-block-traffic-by-country-via-cwp-panel/`,
`${baseUrl}/knowledge-base/how-to-open-a-port-in-csf-firewall-via-cwp-panel/`,
`${baseUrl}/knowledge-base/how-to-delete-a-dns-zones-via-cwp-panel/`,
`${baseUrl}/knowledge-base/how-to-login-aws-linux-server-using-putty/`,
`${baseUrl}/knowledge-base/how-to-login-aws-linux-instance-using-pem-key/`,
`${baseUrl}/knowledge-base/create-a-package-in-cpanel/`,
`${baseUrl}/knowledge-base/how-to-create-email-id-in-cpanel-server/`,
`${baseUrl}/knowledge-base/how-to-create-backup-of-a-website/`,
`${baseUrl}/knowledge-base/how-to-create-csr-in-cpanel/`,
`${baseUrl}/knowledge-base/how-to-restore-backup-in-cpanel/`,
`${baseUrl}/knowledge-base/how-to-change-cpanel-password/`,
`${baseUrl}/knowledge-base/email-forwarding/`,
`${baseUrl}/knowledge-base/create-database-in-phpmyadmin/`,
`${baseUrl}/knowledge-base/import-and-export-database-in-phpmyadmin/`,
`${baseUrl}/knowledge-base/how-to-configure-a-cron-job/`,
`${baseUrl}/knowledge-base/redis-and-php-redis-on-cpanel/`,
`${baseUrl}/knowledge-base/how-to-configure-backups-from-cpanel/`,
`${baseUrl}/knowledge-base/reset-email-account-password-from-cpanel/`,
`${baseUrl}/knowledge-base/how-to-make-a-hidden-file-visible-from-the-cpanel-file-manager/`,
`${baseUrl}/knowledge-base/process-to-restore-database-backup-in-cpanel/`,
`${baseUrl}/knowledge-base/email-forwarders-in-cpanel/`,
`${baseUrl}/knowledge-base/redirect-www-or-non-www-url/`,
`${baseUrl}/knowledge-base/home-directory-backup-in-cpanel/`,
`${baseUrl}/knowledge-base/difference-between-cpanel-whm-and-cwp-panel/`,
`${baseUrl}/knowledge-base/installing-wordpress-on-a-subdomain-using-cpanel/`,
`${baseUrl}/knowledge-base/`,
`${baseUrl}/knowledge-base/vtiger-server-kb/`,
`${baseUrl}/knowledge-base/odoo-server-kb/`,
`${baseUrl}/knowledge-base/gpu-server-kb/`,
`${baseUrl}/knowledge-base/dns-issues-kb/`,
`${baseUrl}/knowledge-base/web-hosting-manager-kb/`,
`${baseUrl}/knowledge-base/ssl-issues-kb/`,
`${baseUrl}/knowledge-base/cpanel-whm-kb/`,
`${baseUrl}/knowledge-base/plesk-kb/`,
`${baseUrl}/knowledge-base/cwp-kb/`,
`${baseUrl}/knowledge-base/cpanel-kb/`,
`${baseUrl}/knowledge-base/aws-kb/`,
`${baseUrl}/knowledge-base/windows-kb/`,
`${baseUrl}/knowledge-base/vps-kb/`,
`${baseUrl}/knowledge-base/streaming-server-kb/`,
`${baseUrl}/knowledge-base/shared-hosting-kb/`,
`${baseUrl}/knowledge-base/reseller-hosting-kb/`,
`${baseUrl}/knowledge-base/email-kb/`,
`${baseUrl}/knowledge-base/dedicated-server-kb/`,
`${baseUrl}/knowledge-base/how-tos-kb/`,
`${baseUrl}/knowledge-base/cloud-servers-kb/`,
`${baseUrl}/knowledge-base/wordpress-kb/`,
`${baseUrl}/knowledge-base/shopping-cart-kb/`,
`${baseUrl}/knowledge-base/prestashop-kb/`,
`${baseUrl}/knowledge-base/open-cart-kb/`,
`${baseUrl}/knowledge-base/cs-cart-kb/`,
`${baseUrl}/knowledge-base/cms-kb/`,
`${baseUrl}/knowledge-base/infinitivehost-client-area-kb/`,
`${baseUrl}/knowledge-base/database-kb/`,
`${baseUrl}/knowledge-base/cloud-flare-cdn-kb/`,
`${baseUrl}/knowledge-base/digital-ocean-kb/`,
`${baseUrl}/knowledge-base/payment-options-kb/`,
`${baseUrl}/knowledge-base/cpanel-kb-2/`,
`${baseUrl}/knowledge-base/sample-page/`,
];

const Sitemap = () => {
  return (
    <>
      <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-8">
              <div className="text-center">
                  <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Sitemap
                    </h1>
                  <p className="text-white max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Find all pages on our website below.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            <ul className="list-group">
              {sitemapLinks.map((url, index) => {
                let displayPath = url.replace(baseUrl, '');
                if (displayPath === '' || displayPath === '/') {
                  displayPath = 'Home';
                } else if (displayPath.startsWith('/')) {
                  displayPath = displayPath.substring(1);
                }

                return (
                  <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                    <a
                      href={url}
                      className="text-decoration-none text-dark"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {displayPath}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        <div className="mt-4 text-center text-muted">
          <small>Total pages listed: {sitemapLinks.length}</small>
        </div>
      </div>
    </>
  );
};


export default Sitemap;